import { Injectable } from '@angular/core';
import { LayoutEnum } from '../../shared/enums/layout.enum';


/**
 * Service to handle window media screen and browser info
 */
@Injectable({
  providedIn: 'root'
})
export class MediaService {
  constructor() { }

  /**
   * Checks if it is mobile or desktop view
   */
  public isMobile(): boolean {
    const winWidth = window ? window.innerWidth : 0;
    return winWidth <= LayoutEnum.MOBILE_MEDIA_WIDTH;
  }

  /**
   * Returns the main/top header height
   */
  public getMainHeaderHeight(): number {
    const headerNav: HTMLElement = document.getElementById('headerNav');
    return headerNav ? headerNav.offsetHeight : 0;
  }

  /**
   * Returns how far down the viewport the chrome pinned to the top reaches. Anything
   * scrolled above this line is painted over and effectively invisible, so it is the
   * offset to apply when scrolling something into view.
   *
   * Two bars can stack here: the fixed application header, and the company page header
   * stuck directly below it. Both are measured live on every call, because both collapse
   * to a shorter bar once the page is scrolled.
   */
  public getStickyChromeHeight(): number {
    const bars: Array<HTMLElement> = [
      document.querySelector('header.header'),
      document.getElementById('company-page-header')
    ];
    return bars.reduce((lowestEdge, bar) =>
      Math.max(lowestEdge, bar ? bar.getBoundingClientRect().bottom : 0), 0);
  }

  /**
   * Get the sub nav + main header height
   */
  public getHeaderOffset(): number {
    const headerSubNav: HTMLElement = document.getElementById('sub-nav');
    return this.getMainHeaderHeight() + headerSubNav.offsetHeight;
  }
}
